"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

require("./index.css");

var prop_types_1 = require("prop-types");

var MenuSwitch = function (_a) {
  var open = _a.open,
      onClick = _a.onClick,
      menuId = _a.menuId;
  var isExpanded = !!open;
  return (0, jsx_runtime_1.jsxs)("button", __assign({
    className: "menu-switch " + open,
    "aria-label": "Toggle Primary Menu",
    title: "Toggle Primary Menu",
    "aria-expanded": isExpanded,
    "aria-controls": menuId || 'navigation',
    onClick: onClick
  }, {
    children: [(0, jsx_runtime_1.jsx)("span", {
      className: "" + open
    }, void 0), (0, jsx_runtime_1.jsx)("span", {
      className: "" + open
    }, void 0), (0, jsx_runtime_1.jsx)("span", {
      className: "" + open
    }, void 0)]
  }), void 0);
};

MenuSwitch.propTypes = {
  menuId: prop_types_1.string,
  onClick: prop_types_1.func.isRequired,
  open: prop_types_1.bool.isRequired
};
exports.default = MenuSwitch;